export default function () {
  let loadMore = document.querySelector(".ajax-load-more");
  let offset = 0;
  if (!loadMore) {
    return;
  }

  loadMore.addEventListener("click", function () {
    offset += 6;
    loadMorePosts(offset);
  });

  function loadMorePosts(offset) {
    console.log(offset, window.location);
	let get = window.location.href + `?&offset=${offset}`;
	console.log(get);
    fetch(get, {
      method: "POST",
    }).then((res) => {
      res.text().then((value) => {
        parsePosts(value);
      });
    });
  }

  function parsePosts(html) {
    var parser = new DOMParser();
	var htmlDoc = parser.parseFromString(html, "text/html");
	let newItems = htmlDoc.querySelectorAll('[data-aoe]');
	for (let i = 0; i < newItems.length; i++) {
		const element = newItems[i];
		let newClass = element.getAttribute('data-aoe');
		element.classList.add(newClass);
	}

	let posts = htmlDoc.querySelector('.posts').innerHTML;
	appendPost(posts);
  }

  function appendPost(html) {
	  let container = document.querySelector('.posts');
	  container.innerHTML+= html;
	  
  }
}
